class InfoBoxElement extends HTMLElement {
  connectedCallback() {
    this._lastScrollY = window.scrollY;
    addEventListener("scroll", this, { passive: true });
  }

  disconnectedCallback() {
    removeEventListener("scroll", this, { passive: true });
  }

  handleEvent(e) {
    if (e.type === "scroll") {
      const y = window.scrollY;
      if (y > this._lastScrollY) {
        if (y - this._lastScrollY > 100) {
          this.toggleAttribute("hide", true);
          this._lastScrollY = y;
        }
      } else {
        this.toggleAttribute("hide", false);
        this._lastScrollY = y;
      }
    }
  }
}

customElements.define("info-box", InfoBoxElement);
